import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import FAQPage from "@/pages/FAQPage";
import ServicePage from "@/pages/ServicePage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/services/:serviceSlug" element={<ServicePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
